var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpressioncouleur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-linecap:round;stroke-width:2px;}.cls-1,.cls-3{stroke:#e6007e;stroke-miterlimit:10;}.cls-2,.cls-3{fill:#e6007e;}.cls-3{stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "impression_couleur",
    "data-name": "impression couleur"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52,43.41H43.41a.61.61,0,0,1-.61-.61.61.61,0,0,1,.61-.62H52A1.22,1.22,0,0,0,53.22,41V26.86A1.23,1.23,0,0,0,52,25.63H14a1.23,1.23,0,0,0-1.23,1.23V41A1.22,1.22,0,0,0,14,42.18h8.58a.61.61,0,0,1,.61.62.61.61,0,0,1-.61.61H14A2.46,2.46,0,0,1,11.53,41V26.86A2.46,2.46,0,0,1,14,24.41H52a2.46,2.46,0,0,1,2.46,2.45V41A2.46,2.46,0,0,1,52,43.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.88,54.45H32.1a.61.61,0,0,1-.61-.62.61.61,0,0,1,.61-.61h1.78a.61.61,0,0,1,.61.61A.61.61,0,0,1,33.88,54.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.41,54.45H38.78a.61.61,0,0,1-.61-.62.61.61,0,0,1,.61-.61h4V40.65H23.18V53.22h5.24a.61.61,0,0,1,.62.61.62.62,0,0,1-.62.62H22.57a.61.61,0,0,1-.61-.62V40a.61.61,0,0,1,.61-.61H43.41A.61.61,0,0,1,44,40V53.83A.61.61,0,0,1,43.41,54.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.09,43.41H43.41a.61.61,0,0,1-.61-.61.61.61,0,0,1,.61-.62h3.07V38.05a.92.92,0,0,0-.92-.92H20.42a.92.92,0,0,0-.92.92v4.13h3.07a.61.61,0,0,1,.61.62.61.61,0,0,1-.61.61H18.89a.61.61,0,0,1-.61-.61V38.05a2.14,2.14,0,0,1,2.14-2.15H45.56a2.14,2.14,0,0,1,2.14,2.15V42.8A.61.61,0,0,1,47.09,43.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.5,46.12h-13a.62.62,0,1,1,0-1.23h13a.62.62,0,1,1,0,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.5,50.15h-13a.61.61,0,1,1,0-1.22h13a.61.61,0,1,1,0,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44,25.63H22a.61.61,0,0,1-.62-.61V12.15a.62.62,0,0,1,.62-.62H38.25a.62.62,0,0,1,.43.18l5.78,5.78a.62.62,0,0,1,.18.43V25A.61.61,0,0,1,44,25.63ZM22.57,24.41H43.41V18.18L38,12.76H22.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.88,18.53H30.1a.61.61,0,0,1-.61-.61V12.15a.61.61,0,0,1,.61-.62.62.62,0,0,1,.62.62v5.16h5.16a.61.61,0,1,1,0,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,31.94a2.16,2.16,0,1,1,2.16-2.16A2.16,2.16,0,0,1,33,31.94Zm0-3.09a.94.94,0,0,0,0,1.87.94.94,0,0,0,0-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33,31.94a2.16,2.16,0,1,1,2.16-2.16h0A2.16,2.16,0,0,1,33,31.94Zm0-3.09a.94.94,0,1,0,.93.93h0a.93.93,0,0,0-.93-.93Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressioncouleur);
export default __webpack_public_path__ + "static/media/impressioncouleur.c5192cc9e2b16e679acf1130ce47a6e3.svg";
export { ForwardRef as ReactComponent };